import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import FilterFormSection from "components/Form/formSection/FilterFormSection";
import { KitchenFilterFormProps, ValueState } from "./KitchenForm.props";
import "./kitchenForm.scss";

const KitchenFilterForm: React.FunctionComponent<KitchenFilterFormProps> = ({
    formData,
    getFormData,
    ExtraField,
    handleChange,
    containerClass,
    resetFormData = false,
}) => {
    const formRef = useRef<HTMLFormElement>(null);
    const [values, setValues] = useState<ValueState>({});

    const handleSubmit = (name: string, value: string) => {
        if (name !== "phone" && value?.length) {
            setValues({ ...values, [name]: value });
        } else if (name === "phone") {
            setValues({ ...values, [name]: value });
        } else if (name.includes("id")) {
            setValues({ ...values, [name]: value });
        }
        if (value?.length === 0) {
            let valuesCopy = { ...values };
            delete valuesCopy[name];
            setValues(valuesCopy);
        }
        getFormData(values);
    };

    useEffect(() => {
        if (values) {
            getFormData(values);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values]);

    useEffect(() => {
        if (values && resetFormData) {
            setValues({});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetFormData]);

    return (
        formData && (
            <Form
                className="form-container filter-form d-inline-block"
                ref={formRef}
            >
                {formData.map((section, sectionIndex) => (
                    <FilterFormSection
                        section={section}
                        key={sectionIndex}
                        containerClass={containerClass}
                        defaultValues={values}
                        handleChange={(val: any, data: any) => {
                            if (handleChange) {
                                handleChange(val, data);
                            }
                        }}
                        extraField={ExtraField}
                        reset={resetFormData}
                        handleSubmit={handleSubmit}
                    />
                ))}
            </Form>
        )
    );
};

export default KitchenFilterForm;
